import type { FaireProductEntity } from "../../entity_types/product";

export const p_ybgea3fv5u: FaireProductEntity = {
  token: "p_ybgea3fv5u",
  type: "product",
  name: "White Flower Condolence Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/196ba4ac1a57e1f6827b08b315052bb1bd7db99110ce6e86207a881d50da0975.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ccbc07544217948e4589c73d3196e39850c2973099212db689d24ca8a924380b.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:41.070Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
